<template>
    <ul v-if="!basketSelect"
        class="shipping-select row"
        :class="{'shipping-select--loader': loading}">
        <li class="col-6 col-sm-4 px-0"
            :class="{'active': basket.shippingCountryId == shippingCountry.id, 'is-disabled': isDisabled}"
            v-for="shippingCountry in shippingCountries"
            :key="shippingCountry.id">
            <a class="nav-link"
               data-toggle="collapse"
               href="#shippingSelect"
               @click="setShippingCountry(shippingCountry.id)"
               :disabled="isDisabled"
               v-tooltip="isDisabled"
               data-boundary="window"
               :data-title="$translate('Ceres::Template.headerChangeDeliveryCountry')"
               :aria-label="$translate('Ceres::Template.headerChangeDeliveryCountry')">
                <i :class="'flag-icon flag-icon-' + shippingCountry.isoCode2.toLowerCase()"></i>
                {{ shippingCountry.currLangName }}
            </a>
        </li>
    </ul>
    <div v-else class="shipping-select" :class="{'shipping-select--loader': loading}">
        <div class="h3" v-if="showTitle">
            {{ $translate('Ceres::Template.headerSelectShippingCountry') }}
        </div>
        <select v-if="shippingCountries.length > 1" class="form-control"
                @change="setShippingCountry($event.target.value)">
            <option v-for="shippingCountry in shippingCountries"
                    :value="shippingCountry.id"
                    :disabled="isDisabled"
                    :selected="basket.shippingCountryId == shippingCountry.id"
                    :key="shippingCountry.id">
                {{ shippingCountry.currLangName }}
            </option>
        </select>
        <div v-else>
            {{ getCountryName(localization.shippingCountryId) }}
        </div>
    </div>
</template>

<script>
import {removeUrlParam} from "ceres/app/services/UrlService";
import {mapState, mapGetters} from "vuex";

export default {
    props:
        {
            disableInput: Boolean,
            openBasketPreview: Boolean,
            basketSelect: Boolean,
            showTitle: {
                type: Boolean,
                default: true
            }
        },

    data()
        {
            return {
                loading: false
            }
        },

    computed:
        {
            ...mapState({
                localization: state => state.localization,
                basket: state => state.basket.data,
                basketItems: state => state.basket.items,
                countryReload: state => state.localization.reload
            }),

            ...mapGetters([
                "getCountryName"
            ]),

            isDisabled() {
                return !!this.basket.customerInvoiceAddressId || !!this.basket.customerShippingAddressId || this.disableInput;
            },

            /**
             * If an item in basket has free4 = '1' the following shipping country's are hidden, because the item
             * can not be delivered in the following country's:
             *      - 1   => Germany
             *      - 2   => Austria
             *      - 4   => Switzerland
             *      - 255 => Helgoland Germany
             */
            shippingCountries() {

                if(this.basketItems.length > 0) {

                    let shippingCountries = [];

                    if(typeof this.basketItems.find(item => item.variation.data.item.free4 === "1") !== "undefined") {
                        for(let i = 0; i < this.localization.shippingCountries.length; i++) {
                            if(![1,2,4,255].includes(this.localization.shippingCountries[i].id)) {
                                shippingCountries.push(this.localization.shippingCountries[i])
                            }
                        }

                        return shippingCountries;
                    }
                }

                return this.localization.shippingCountries;

            }
        },

    mounted()
        {
            removeUrlParam("openBasketPreview");
        },

    methods:
        {
            setShippingCountry(id) {
                if(!this.isDisabled) {

                    this.loading = true

                    this.$store.dispatch("selectShippingCountry", {
                        shippingCountryId: id,
                        openBasketPreview: this.openBasketPreview
                    }).finally(() => {
                        if(!this.countryReload) {
                            this.loading = false;
                        }
                    });
                }
            }
        }
}
</script>
